module.exports = __webpack_public_path__ + "static/img/2areaB_39.1b776fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_39.png
// module id = 1156
// module chunks = 1